import type { ReactNode } from 'react';
import { UserCog } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useAuth } from '../lib/auth';

export default function Layout({ children }: { children: ReactNode }) {
  const { user, impersonatedBy, stopImpersonating } = useAuth();

  return (
    <div className="min-h-screen flex flex-col">
      {impersonatedBy && (
        <div className="bg-amber-500 text-white text-sm px-4 py-2 flex items-center justify-center gap-3 flex-wrap sticky top-0 z-[60]">
          <UserCog className="w-4 h-4" />
          <span>Viewing as <strong>{user?.full_name || user?.email}</strong> ({user?.email})</span>
          <button onClick={stopImpersonating} className="underline font-medium hover:text-amber-100">
            Return to {impersonatedBy.full_name || impersonatedBy.email}
          </button>
        </div>
      )}
      <Navbar />
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      <Footer />
    </div>
  );
}
